import { injectable } from 'inversify';
import { IQuayService } from './IQuayService';
import { ApiResponse, QuayDto } from '@/types/webapi';
import { ApiService } from './ApiService';

@injectable()
export class QuayService extends ApiService implements IQuayService {
    async getQuays(): Promise<QuayDto[]> {
        const response = await this.axios.get<ApiResponse<QuayDto[]>>('/api/v1.0/quays');
        return response.data.data;
    }
}
